import { Card, Stack } from "@mui/material";
import { Handle, Position } from "reactflow";
import { ProcessorIcon } from "../../Icons";
import styles from "../../Cards/cards.module.scss";

export function DummyProcessorNode() {
  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Card className={styles["dummy-processor-card"]}>
        <Stack
          width="100%"
          height="100%"
          justifyContent="center"
          alignItems="center"
        >
          <ProcessorIcon />
        </Stack>
      </Card>
      <Handle type="source" position={Position.Right} />
    </>
  );
}
